// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__2sTLv","leftSection":"Header_leftSection__1k5Zj"};